import React from 'react'
import styled from 'styled-components'

interface props {
  ctl: boolean
}

export default function LeftText({ ctl }: props) {
  return (
    <Card>
      <Header>Let’s Chat About Your Health</Header>
      <BestFor>Ready to talk with a Tria Health {ctl ? 'coach' : 'pharmacist'}? Use the calendar to pick a time that works for you.</BestFor>
      <Expect>
        <b>Here’s what you can expect:</b>
      </Expect>

      <ul>
        <Li>
          <b>First-time consults</b> usually take <b>{ctl ? '45 to 60' : '20 to 30'} minutes</b>
        </Li>
        <Li>
          <b>Follow-ups</b> are quicker
        </Li>
        <Li>Your {ctl ? 'health coach' : 'pharmacist'} will give you a call at your scheduled time from a 913 area code.</Li>
      </ul>
    </Card>
  )
}

const Card = styled.div`
  border-right: 1px solid #bdbdbd;
  font-family: Raleway;
  max-width: 350px;
  height: 640px;
  padding: 40px;
  text-align: left;
  @media only screen and (max-width: 600px) {
    padding: 40px 40px 0px;
    margin-top: 20px;
    border-right: none;
    height: fit-content;
  }
`

const Header = styled.h1`
  font-weight: 700;
  font-size: 34px;
  margin-bottom: 20px;
`

const BestFor = styled.p`
  font-size: 16px;
  margin-bottom: 60px;
`

const Expect = styled.p`
  font-size: 16px;
  margin-bottom: 20px;
`

const Li = styled.li`
  margin-bottom: 10px;
`
